<template>
    
        <el-dropdown 
            v-if="porlet.attr.dropDown" 
            trigger="click" 
            @command="handleCommand"
            :style="{width: '100%', display: actions.length ? 'block' : 'none'}">
            <el-button style="width: 100%" size="small">
                {{porlet.titulo}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                    v-for="(action,i) in actions"
                    :key="i"
                    :command="action"
                    :icon="action.icon || 'el-icon-arrow-right'">
                    {{action.titulo}}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <el-menu id="menu-actions" v-else>
            <el-menu-item-group v-if="actions && actions.length">
                <span slot="title">{{porlet.titulo}}</span>
                <el-menu-item 
                    index="1-1" 
                    v-for="(action,i) in actions" 
                    :key="i" 
                    @click="porlet.events.clickAction(action)">
                    <i :class="['menu-actions-icon', action.icon || 'el-icon-arrow-right']"></i> 
                    <span slot="title">{{action.titulo}}</span>
                </el-menu-item>
            </el-menu-item-group>
        </el-menu>

</template>

<script>
    import {mapState} from 'vuex'

	export default {
        name: 'MenuActions',
        props: {
            id: [Number,String],
			ficha: Object,
            porlet: Object
		},
        computed: {
			actions () {

                let items = []

                if (this.porlet && this.porlet.actions && this.ficha.actions) {
                    items = Object.keys(this.ficha.actions)
                    .filter(action => typeof this.ficha.actions[action] === 'object' && this.porlet.actions.includes(action))
                    .map(accion => {
                        let m = this.ficha.actions[accion]
                        return {
                            ...m,
                            auto: m.auto || true,
                            function: m.function || null,
                            url: m.url ? m.url.replace('@@id@@',this.id) : null
                        }
                    })
                }

                return items

            }
		},
        methods: {
            handleCommand(action) {
                this.porlet.events.clickAction(action)
            }
        }
	}
</script>

<style lang="scss">
#menu-actions {
    .menu-actions-icon {
        margin-right: 5px;
        width: 24px;
        text-align: center;
        font-size: 18px;
        vertical-align: middle;
    }
}
</style>